import { IPaginatedTransactionHistory } from "../../interfaces/transaction";
import { IFetchTransactionHistoryAction } from "../actions/transactionHistory.action";
import { ActionType } from "../action_types";

interface ITransactionHistoryState {
  paginatedTransactionHistory: IPaginatedTransactionHistory;
}

const initialState: ITransactionHistoryState = {
  paginatedTransactionHistory: { data: [], page: 0, total: 0, last_page: 0 },
};

const transactionHistoryReducer =  (state = initialState, action: IFetchTransactionHistoryAction): ITransactionHistoryState => {
  switch (action.type) {
    case ActionType.FETCH_TRANSACTION_HISTORY:
      return {...state, paginatedTransactionHistory: action.payload.paginatedTransactionHistory}

    default:
      return {...state}
  }
}

export default transactionHistoryReducer
